import { render, staticRenderFns } from "./transformationsConfigurations.vue?vue&type=template&id=49ea61e4&scoped=true&"
import script from "./transformationsConfigurations.vue?vue&type=script&lang=js&"
export * from "./transformationsConfigurations.vue?vue&type=script&lang=js&"
import style0 from "./transformationsConfigurations.vue?vue&type=style&index=0&id=49ea61e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ea61e4",
  null
  
)

export default component.exports